import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "hasMultipleVariant",
    "variantsSection",
    "multipleVariant",
    "comboSection",
    "stockSection",
    "measurementsSection",
    "supplierSection",
    "productType",
    "buyingPrice",
    "wholeSalePrice",
    "quotePrice",
    "retailPrice",
    "promoPrice",
    "ecommercePrice",
    "shipmentPrice",
    "buyingPriceError",
    "setPriceAuto",
    "manualPriceSection",
    "autoPriceSection",
    "wholeSalePricePercValue",
    "RetailPricePercValue",
    "QuotePricePercValue",
    "PromoPricePercValue",
    "EcommercePricePercValue",
    "wholeSalePricePerc",
    "retailPricePerc",
    "quotePricePerc",
    "promoPricePerc",
    "ecommercePricePerc",
    "fxPriceSection",
    "basePriceDisplay"
  ];

  static values = {
    warehouses: Array,
    itemizable: String,
  };

  get tomSelectController() {
    return this.application.getControllerForElementAndIdentifier(
        this.element,
        "tom-select"
    );
  }

  connect() {
    this.initializeTooltips(); // Initialize tooltips
    this.hideAllSections();
    this.toggleSection(this.productTypeTarget.value);
    this.setPricePerc();
    this.updateBasePrice();

    if (this.setPriceAutoTarget.checked) {
      this.updatePricesFromPercentages();
    }
  }

  productTypeChanged(event) {
    this.hideAllSections();
    this.toggleSection(event.target.value);
  }

  // Initialize Bootstrap tooltips for the Dimensions label
  initializeTooltips() {
    const dimensionsLabel = this.measurementsSectionTarget.querySelector('label[for=""]');
    if (dimensionsLabel) {
      const tooltipIcon = dimensionsLabel.querySelector('[data-toggle="tooltip"]');
      if (tooltipIcon && window.jQuery && typeof window.jQuery.fn.tooltip === "function") {
        window.jQuery(tooltipIcon).tooltip();
      }
    }
  }

  toggleSection(productType) {
    if (productType == "Combo") {
      this.comboSectionTarget.classList.toggle("d-none");
    } else if (productType == "Standard") {
      this.variantsSectionTarget.classList.toggle("d-none");
      this.stockSectionTarget.classList.toggle("d-none");
      this.measurementsSectionTarget.classList.toggle("d-none");
      this.supplierSectionTarget.classList.toggle("d-none");
    } else if (productType == "Service") {
      this.buyingPriceTarget.value = "0.0";
      this.buyingPriceTarget.disabled = true;
    } else {}
  }

  toggleFxPrice() {
    if (this.hasFxPriceSectionTarget) {
      this.fxPriceSectionTarget.classList.toggle("d-none");
    }
  }

  setPricePerc() {
    const checked = this.setPriceAutoTarget.checked;

    if (checked) {
      this.manualPriceSectionTarget.classList.add("d-none");
      if (this.autoPriceSectionTarget) this.autoPriceSectionTarget.classList.remove("d-none");
    } else {
      this.manualPriceSectionTarget.classList.remove("d-none");
      if (this.autoPriceSectionTarget) this.autoPriceSectionTarget.classList.add("d-none");
    }
  }

  updatePricesFromPercentages(event) {
    const buyingPrice = parseFloat(this.buyingPriceTarget.value) || 0;
    const shipmentPrice = parseFloat(this.shipmentPriceTarget.value) || 0;
    const basePrice = buyingPrice + shipmentPrice;

    // Helper function to update value badge and associated input
    function updateBadgeAndInput(percTarget, badgeTarget, inputTarget) {
      if (!percTarget || !badgeTarget || !inputTarget) return;
      const perc = parseFloat(percTarget.value);
      if (!isNaN(perc) && percTarget.value !== "") {
        const value = (basePrice * (1 + perc / 100)).toFixed(2);
        badgeTarget.textContent = `Value: ${value}`;
        badgeTarget.classList.remove("d-none");
        inputTarget.value = value; // update the associated input field
      } else {
        badgeTarget.textContent = "";
        badgeTarget.classList.add("d-none");
        inputTarget.value = ""; // clear the input if percentage is blank
      }
    }

    // Wholesale
    if (
      this.hasWholeSalePricePercTarget &&
      this.hasWholeSalePricePercValueTarget &&
      this.hasWholeSalePriceTarget
    ) {
      updateBadgeAndInput(
        this.wholeSalePricePercTarget,
        this.wholeSalePricePercValueTarget,
        this.wholeSalePriceTarget
      );
    }
    // Retail
    if (
      this.hasRetailPricePercTarget &&
      this.hasRetailPricePercValueTarget &&
      this.hasRetailPriceTarget
    ) {
      updateBadgeAndInput(
        this.retailPricePercTarget,
        this.RetailPricePercValueTarget,
        this.retailPriceTarget
      );
    }
    // Quote
    if (
      this.hasQuotePricePercTarget &&
      this.hasQuotePricePercValueTarget &&
      this.hasQuotePriceTarget
    ) {
      updateBadgeAndInput(
        this.quotePricePercTarget,
        this.QuotePricePercValueTarget,
        this.quotePriceTarget
      );
    }
    // Promo
    if (
      this.hasPromoPricePercTarget &&
      this.hasPromoPricePercValueTarget &&
      this.hasPromoPriceTarget
    ) {
      updateBadgeAndInput(
        this.promoPricePercTarget,
        this.PromoPricePercValueTarget,
        this.promoPriceTarget
      );
    }
    // Ecommerce
    if (
      this.hasEcommercePricePercTarget &&
      this.hasEcommercePricePercValueTarget &&
      this.hasEcommercePriceTarget
    ) {
      updateBadgeAndInput(
        this.ecommercePricePercTarget,
        this.EcommercePricePercValueTarget,
        this.ecommercePriceTarget
      );
    }
  }

  updateBasePrice() {
    const buying = parseFloat(this.buyingPriceTarget.value) || 0;
    const shipment = parseFloat(this.shipmentPriceTarget.value) || 0;
    if (this.hasBasePriceDisplayTarget) {
      this.basePriceDisplayTarget.textContent = (buying + shipment).toFixed(2);
    }
  }

  hideAllSections() {
    this.comboSectionTarget.classList.add("d-none");
    this.variantsSectionTarget.classList.add("d-none");
    this.stockSectionTarget.classList.add("d-none");
    this.measurementsSectionTarget.classList.add("d-none");
    this.supplierSectionTarget.classList.add("d-none");
  }

  hasMultipleVariantChange() {
    this.variantsSectionTarget.classList.toggle("d-none");
  }

  addAssociation() {
    var content = this.templateTarget.innerHTML.replace(
        /TEMPLATE_RECORD/g,
        this.itemsTarget.querySelectorAll(".nested-fields").length
    );
    this.templateTarget.insertAdjacentHTML("afterend", content);
  }

  removeAssociation(event) {
    event.preventDefault();
    let item = event.target.closest(".nested-fields");
    item.querySelector("input[name*='_destroy']").value = 1;
    item.style.display = "none";
  }

  multipleVariantChange() {
    var variants = this.tomSelectController.select.items;
    var last_variant = variants.pop();
    if (last_variant) {
      this.warehousesValue.forEach((warehouse, i) => {
        this.addAssociation();
        this.addFieldValues(warehouse, last_variant);
      });
    }
  }
  addFieldValues(warehouse, last_variant) {
    var items = this.itemsTarget.querySelectorAll(".nested-fields");
    var item = items[0];
    item.querySelector("input[name*='warehouse_id']").value = warehouse.id;
    item.querySelector("input[name*='name']").value = last_variant;
    item.querySelector("input[name*='ware_house']").value = warehouse.name;
    item.querySelector("input[name*='quantity']").value = 0;
    item.querySelector("input[name*='buying_price']").value = 0;
    item.querySelector("input[name*='retail_price']").value = 0;
  }

  checkBuyingPrice() {
    const buyingPrice = parseFloat(this.buyingPriceTarget.value);
    const productType = this.productTypeTarget.value;
    if (productType !== "Service" && buyingPrice === 0) {
      this.buyingPriceErrorTarget.textContent = "Buying price must be greater than 0";
    } else {
      this.buyingPriceErrorTarget.textContent = "";
    }
  }
}
